const MANUFACTURER_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  remark: '備註',
};

export {
  MANUFACTURER_FIELD_LABELS,
};
